
import { defineComponent } from "vue";

import useTodo from "../composables/useTodo";
import Check from "./shared/Check.vue";
import Cross from "./shared/Cross.vue";

export default defineComponent({
  name: "TodoItem",

  components: { Check, Cross },

  props: {
    todo: Object
  },

  setup() {
    const { toggleTodo, removeTodo } = useTodo();

    return { toggleTodo, removeTodo };
  }
});
